import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/rem'
import axios from 'axios'
import MetaInfo from 'vue-meta-info'
import {getSIgn} from "./utils/sign";
Vue.prototype.$getSIgn = getSIgn;
import { encrypt } from '@/utils/encryp.js';
Vue.prototype.encrypt = encrypt
Vue.use(MetaInfo);
let urlType = {
  dev: 'https://192.168.2.56:8443',
  line: 'https://cliplab-flash.jianyingkeji.net:10796',
  test: 'https://test-cliplab-app.jianyingkeji.net:8443'
};
switch (process.env.VUE_APP_TITLE) {
  case 'production':
    axios.defaults.baseURL = urlType.line;
    break;
  case 'test':
    axios.defaults.baseURL = urlType.test;
    break;
}
axios.defaults.withCredentials = true;
axios.defaults.headers['cliplab-signVer'] = 'v2';
axios.defaults.crossDomain=true;
Vue.prototype.$axios = axios;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
